import clsx from "clsx";
import React from "react";
import { Box, BoxProps, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { ReactComponent as EmptyIcon } from "../../icons/FitnessWeightlifting.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  text: {
    textAlign: "center",
    margin: theme.spacing(2, 10),
  },
}));

export interface UserExerciseResultsEmptyProps extends BoxProps {}

export function UserExerciseResultsEmpty(props: UserExerciseResultsEmptyProps) {
  const { className, ...other } = props;
  const s = useStyles();

  return (
    <Box className={clsx(s.root, className)} {...other}>
      <EmptyIcon />
      <Typography variant="subtitle1" className={s.text}>
        There are no completed exercises for the current filter criteria.
      </Typography>
    </Box>
  );
}
